export const formValidation = (type, name, required, value) => {
    let defaultErr = '', error = "";
    switch(type){
        case 'input':
            defaultErr = `Enter the ${name}`;
            error = required ? (value ? '' : defaultErr) : '';
            return error;

        case 'textarea':
            defaultErr = `Enter the ${name}`;
            error = required ? (value ? '' : defaultErr) : '';
            return error;

        case 'date':
            defaultErr = `Select the ${name} date`;
            error = required ? (value ? '' : defaultErr) : '';
            return error;

        case 'upload':
            defaultErr = `Upload the ${name}`;
            error = required ? ((value && value.length !== 0) ? '' : defaultErr) : '';
            return error;

        case 'checkbox':
            defaultErr = `Select the ${name}`;
            error = required ? (value ? '' : defaultErr) : '';
            return error;

        case 'radio':
            defaultErr = `Select the ${name}`;
            error = required ? (value ? '' : defaultErr) : '';
            return error;

        case 'dropdown':
            defaultErr = `Select the ${name}`;
            error = required ? (value ? '' : defaultErr) : '';
            return error;

        case 'breakline':
            error = '';
            return error;

        case 'disclaimer':
            defaultErr = `Select the ${name}`;
            error = required ? (value ? '' : defaultErr) : '';
            return error;

        case 'map':
            defaultErr = `Select the ${name} co-ordinates`;
            error = required ? (value ? '' : defaultErr) : '';
            return error;

        default:
            return 'Enter the valid form details';
    }
};